import React, { useEffect, useState } from "react";
import { Form, FormGroup, Label } from "reactstrap";
import Utils from "../../utils";
import { toast } from "react-toastify";
import {
  createTax,
  getTimeZoneList,
  updateTax,
} from "../../services/MoloniServices";
import { Tabs, Tab } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import ConfigDB from "../../config";

const AddTaxAndFees = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { state } = useLocation();
  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);
  const [taxMoloniData, setTaxMoloniData] = useState({
    id: "",
    name: "",
    value: "",
    type: "",
    saft_type: "",
    vat_type: "",
    stamp_tax: "",
    exemption_reason: "",
    fiscal_zone: "",
    active_by_default: 0,
    moloni_id: "",
  });

  let errorsObj = {
    name: "",
    value: "",
    type: "",
    saft_type: "",
    vat_type: "",
    stamp_tax: "",
    exemption_reason: "",
    fiscal_zone: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [currentStep, setCurrentStep] = useState("step1");
  const [timeZoneList, setTimeZoneList] = useState([]);

  useEffect(() => {
    if (state) {
      setTaxMoloniData({
        id: state?.id,
        name: state?.name,
        value: state?.value,
        type: state?.type,
        saft_type: state?.safe_type,
        vat_type: state?.vat_type,
        stamp_tax: state?.stamp_tax,
        exemption_reason: state?.exemption_reason,
        fiscal_zone: state?.fiscal_zone,
        active_by_default: state?.active_by_default,
        moloni_id: state?.moloni_id,
      });
    }
  }, [state]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getTimeZoneList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].code,
            label: response.data[i].code,
          });
        }

        setTimeZoneList(list);
      })
      .catch((err) => {});
  }, []);

  const handleSubmitForm = (e) => {
    e.preventDefault();
    let error = false;
    let errorObj = { ...errorsObj };
    if (!taxMoloniData.name) {
      errorObj.name = `Name is required.`;
      error = true;
    }

    if (!taxMoloniData.value) {
      errorObj.value = `Value is required.`;
      error = true;
    }

    if (!taxMoloniData.type) {
      errorObj.type = `Type is required.`;
      error = true;
    }

    if (!taxMoloniData.saft_type) {
      errorObj.saft_type = `Saft type is required.`;
      error = true;
    }

    if (taxMoloniData?.saft_type === 1) {
      if (!taxMoloniData.vat_type) {
        errorObj.vat_type = `Vat type is required.`;
        error = true;
      }
    }

    if (taxMoloniData?.saft_type === 2) {
      if (!taxMoloniData.stamp_tax) {
        errorObj.stamp_tax = `Stamp tax code is required.`;
        error = true;
      }
    }

    if (!taxMoloniData.fiscal_zone) {
      errorObj.fiscal_zone = `Fiscal zone is required.`;
      error = true;
    }

    if (!taxMoloniData.exemption_reason) {
      errorObj.exemption_reason = `Exemption reason is required.`;
      error = true;
    }

    setErrors(errorObj);
    Utils.focusError();

    if (error) return;

    setIsModifyButtonLoad(true);

    let data = {
      company_id: "269134",
      name: taxMoloniData?.name,
      value: taxMoloniData?.value,
      type: taxMoloniData?.type,
      saft_type: taxMoloniData?.saft_type,
      vat_type: taxMoloniData?.saft_type === 1 ? taxMoloniData?.vat_type : "",
      stamp_tax: taxMoloniData?.saft_type === 2 ? taxMoloniData?.stamp_tax : "",
      exemption_reason: taxMoloniData?.exemption_reason,
      fiscal_zone: taxMoloniData?.fiscal_zone,
      active_by_default: taxMoloniData?.active_by_default,
    };

    let updateData = {
      company_id: "269134",
      id: taxMoloniData?.id,
      name: taxMoloniData?.name,
      value: taxMoloniData?.value,
      type: taxMoloniData?.type,
      saft_type: taxMoloniData?.saft_type,
      vat_type: taxMoloniData?.saft_type === 1 ? taxMoloniData?.vat_type : "",
      stamp_tax: taxMoloniData?.saft_type === 2 ? taxMoloniData?.stamp_tax : "",
      exemption_reason: taxMoloniData?.exemption_reason,
      fiscal_zone: taxMoloniData?.fiscal_zone,
      active_by_default: taxMoloniData?.active_by_default,
      tax_id: taxMoloniData?.moloni_id,
    };

    if (taxMoloniData?.id) {
      updateTax(updateData)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/taxAndFees");
          setIsModifyButtonLoad(false);
          setTaxMoloniData({
            id: "",
            name: "",
            value: "",
            type: "",
            saft_type: "",
            vat_type: "",
            stamp_tax: "",
            exemption_reason: "",
            fiscal_zone: "",
            active_by_default: 0,
            moloni_id: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    } else {
      createTax(data)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/taxAndFees");

          setIsModifyButtonLoad(false);
          setTaxMoloniData({
            id: "",
            name: "",
            value: "",
            type: "",
            saft_type: "",
            vat_type: "",
            stamp_tax: "",
            exemption_reason: "",
            fiscal_zone: "",
            active_by_default: 0,
            moloni_id: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    }
  };

  const handleCheckboxDefaultChange = (e) => {
    setTaxMoloniData({
      ...taxMoloniData,
      active_by_default: e.target.checked ? 1 : 0,
    });
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6 d-flex align-items-center"></div>

              <div className="col-sm-6 text-end">
                <h1 className="page-title">{"Tax And Fees"}</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="row justify-content-start">
              <div className="col-md-12">
                <Form method={`post`} onSubmit={handleSubmitForm}>
                  <div className="card card-primary">
                    <div className="card-body">
                      <div className="row justify-content-start">
                        <Tabs
                          activeKey={currentStep}
                          onSelect={(k) => setCurrentStep(k)}
                          className="mb-3"
                          style={{
                            marginTop: "-11px",
                            marginLeft: "-3px",
                            width: "137px",
                            borderRadius: "0px",
                          }}
                        >
                          <Tab eventKey="step1" title="Main">
                            <div className="row">
                              <div className="col-md-6">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("name")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={taxMoloniData.name}
                                        onChange={(e) => {
                                          setTaxMoloniData({
                                            ...taxMoloniData,
                                            name: e.target.value,
                                          });
                                        }}
                                        name={`name`}
                                        maxLength={50}
                                        placeholder="Name"
                                      />
                                    </div>
                                    {errors.name && (
                                      <span className="input-error">
                                        {errors.name}
                                      </span>
                                    )}
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-6">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("value")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="number"
                                        value={taxMoloniData.value}
                                        onChange={(e) => {
                                          setTaxMoloniData({
                                            ...taxMoloniData,
                                            value: e.target.value,
                                          });
                                        }}
                                        name={`value`}
                                        maxLength={50}
                                        placeholder="Value"
                                      />
                                    </div>
                                    {errors.value && (
                                      <span className="input-error">
                                        {errors.value}
                                      </span>
                                    )}
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-6">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my ms-2">
                                    {t("type")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        className="my-select-v"
                                        options={ConfigDB?.data?.typeList}
                                        value={ConfigDB.data.typeList.find(
                                          (item) =>
                                            item.value == taxMoloniData.type
                                        )}
                                        onChange={(selectedOption) => {
                                          setTaxMoloniData({
                                            ...taxMoloniData,
                                            type: selectedOption
                                              ? selectedOption.value
                                              : "",
                                          });
                                        }}
                                        isSearchable={true}
                                        isClearable={true}
                                        placeholder={"Select Type"}
                                      />
                                    </div>
                                    {errors.type && (
                                      <span className="input-error">
                                        {errors.type}
                                      </span>
                                    )}
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-6">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("saft_type")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        className="my-select-v"
                                        options={ConfigDB?.data?.saftTypeList}
                                        value={ConfigDB.data.saftTypeList.find(
                                          (item) =>
                                            item.value ==
                                            taxMoloniData.saft_type
                                        )}
                                        onChange={(selectedOption) => {
                                          setTaxMoloniData({
                                            ...taxMoloniData,
                                            saft_type: selectedOption
                                              ? selectedOption.value
                                              : "",
                                          });
                                        }}
                                        isSearchable={true}
                                        isClearable={true}
                                        placeholder={"Select Saft type"}
                                      />
                                    </div>
                                    {errors.saft_type && (
                                      <span className="input-error">
                                        {errors.saft_type}
                                      </span>
                                    )}
                                  </div>
                                </FormGroup>
                              </div>

                              {taxMoloniData?.saft_type === 1 && (
                                <div className="col-md-6">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("vat_type")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={ConfigDB?.data?.vatTypeList}
                                          value={ConfigDB.data.vatTypeList.find(
                                            (item) =>
                                              item.value ==
                                              taxMoloniData.vat_type
                                          )}
                                          onChange={(selectedOption) => {
                                            setTaxMoloniData({
                                              ...taxMoloniData,
                                              vat_type: selectedOption
                                                ? selectedOption.value
                                                : "",
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={"Select Saft type"}
                                        />
                                      </div>
                                      {errors.vat_type && (
                                        <span className="input-error">
                                          {errors.vat_type}
                                        </span>
                                      )}
                                    </div>
                                  </FormGroup>
                                </div>
                              )}

                              {taxMoloniData?.saft_type === 2 && (
                                <div className="col-md-6">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("stamp_tax")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <input
                                          className="form-control input-search"
                                          type="text"
                                          value={taxMoloniData.stamp_tax}
                                          onChange={(e) => {
                                            setTaxMoloniData({
                                              ...taxMoloniData,
                                              stamp_tax: e.target.value,
                                            });
                                          }}
                                          name={`stamp_tax`}
                                          maxLength={50}
                                          placeholder="Stamp tax code"
                                        />
                                      </div>
                                      {errors.stamp_tax && (
                                        <span className="input-error">
                                          {errors.stamp_tax}
                                        </span>
                                      )}
                                    </div>
                                  </FormGroup>
                                </div>
                              )}

                              <div className="col-md-6">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("fiscal_zone")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        className="my-select-v"
                                        options={timeZoneList}
                                        value={timeZoneList.find(
                                          (item) =>
                                            item.value ==
                                            taxMoloniData.fiscal_zone
                                        )}
                                        onChange={(selectedOption) => {
                                          setTaxMoloniData({
                                            ...taxMoloniData,
                                            fiscal_zone: selectedOption
                                              ? selectedOption.value
                                              : "",
                                          });
                                        }}
                                        isSearchable={true}
                                        isClearable={true}
                                        placeholder={"Select Fiscal Zone"}
                                      />
                                    </div>
                                    {errors.fiscal_zone && (
                                      <span className="input-error">
                                        {errors.fiscal_zone}
                                      </span>
                                    )}
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-6">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("exemption_reason")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={taxMoloniData.exemption_reason}
                                        onChange={(e) => {
                                          setTaxMoloniData({
                                            ...taxMoloniData,
                                            exemption_reason: e.target.value,
                                          });
                                        }}
                                        name={`exemption_reason`}
                                        maxLength={50}
                                        placeholder="Exemption Reason"
                                      />
                                    </div>
                                    {errors.exemption_reason && (
                                      <span className="input-error">
                                        {errors.exemption_reason}
                                      </span>
                                    )}
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-6">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("active_by_default")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <div className="form-check">
                                        <input
                                          className="my-checkbox-1 form-check-input"
                                          type="checkbox"
                                          checked={
                                            taxMoloniData.active_by_default ===
                                            1
                                          }
                                          onChange={handleCheckboxDefaultChange}
                                        />
                                        <label className="form-check-label pl-6">
                                          {t("active_by_default")}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-6"></div>
                            </div>
                          </Tab>
                        </Tabs>
                      </div>
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col ms-2">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => navigate("/taxAndFees")}
                      >
                        <i className="bi bi-arrow-left"> </i> {t("back")}
                      </button>
                    </div>
                    <div className="col">
                      <div className="d-flex justify-content-end nxt-btn">
                        {isModifyButtonLoad === true ? (
                          <button type="submit" className="btn btn-primary">
                            Loading...
                          </button>
                        ) : (
                          <button type="submit" className="btn btn-primary">
                            {t("submit")} <i className="bi bi-check2"></i>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AddTaxAndFees;
